const darkPalette = {
  text: {
    primary: '#F4F0FF',
    secondary: '#A89BC4',
    disabled: '#6E6485',
  },
  primary: {
    dark: '#8B6CF6',
    main: '#AE82F1',
    light: '#D2B8FF',
  },
  secondary: {
    dark: '#A89BC4',
    main: '#F4F0FF',
    light: '#E8DEFF',
    background: '#1A1228',
  },
  border: {
    main: '#6E6485',
    light: '#2A1F45',
    background: '#0F0B16',
  },
  error: {
    dark: '#AC2C3B',
    main: '#FF5F72',
    light: '#FFB4BD',
    background: '#2F2527',
  },
  success: {
    dark: '#028D4C',
    main: '#00B460',
    light: '#81C784',
    background: '#1F2920',
  },
  info: {
    dark: '#52BFDC',
    main: '#5FDDFF',
    light: '#B7F0FF',
    background: '#19252C',
  },
  warning: {
    dark: '#C04C32',
    main: '#FF8061',
    light: '#FFBC9F',
    background: '#2F2318',
  },
  background: {
    default: '#0F0B16',
    main: '#0F0B16',
    paper: '#16101F',
    light: '#1A1228',
  },
  backdrop: {
    main: '#6E6485',
  },
  logo: {
    main: '#F4F0FF',
    background: '#2A1F45',
  },
  static: {
    main: '#0F0B16',
  },
}

export default darkPalette
